import { render, staticRenderFns } from "./InvIndex.vue?vue&type=template&id=9b2197dc&scoped=true"
import script from "./InvIndex.vue?vue&type=script&lang=js"
export * from "./InvIndex.vue?vue&type=script&lang=js"
import style0 from "./InvIndex.vue?vue&type=style&index=0&id=9b2197dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2197dc",
  null
  
)

export default component.exports